/*
	Компілюється у файл
*/
process.env.NODE_ENV === 'production' ? true : require('__page/bitrix24.html');

/*
	Підключаєм конструктор модулів
*/
const mc = require('__libs/ModuleConstructor.js');
const ScrollDetective = require('./scroll-detective');

/**
	Запускаєм конструктор модулів. Аргументом приймає масив назв vue-компонентів,
	які треба включити в процес збірки проекту.
	@type {Array<String>}
*/
mc(['Form', 'Navigation', 'Slider', 'GoogleMap']);

var sd = new ScrollDetective({
	onPartlyVisible: el => {
		if(el.classList.contains('Bottom-map')) {
			// console.log(window.VueInstances.GoogleMap['bottom-map']);
			window.VueInstances.GoogleMap['bottom-map'].$children[0].$children[0].init()
		}
	},
	onVisible: el => {
		if(el.classList.contains('Bottom-map')) {
			// console.log(window.VueInstances.GoogleMap['bottom-map']);
			window.VueInstances.GoogleMap['bottom-map'].$children[0].$children[0].init()
		}
	}
});

sd.addBlocks(".Bx24-online-demo .animation");
sd.addBlocks(".Bx24-buy .grid li");
sd.addBlocks(".Bottom-map");
sd.checkStates();
sd.addScrollEvent();

/*
	Запускаєм скріпти html компонентів
*/
STACK.forEach(f => {
	f($);
})



// WEBPACK FOOTER //
// ./entries/bitrix24.js